(function () {
  const MODAL_ID = 'gale-hsa-modal';

  function labelForType(type) {
    if (type === 'medical_mcc') return 'HSA/FSA Accepted.';
    if (type === 'dual_purpose') return 'HSA/FSA Eligible for qualified customers.';
    return 'HSA/FSA Eligible.';
  }

  function readVariants(widget) {
    const data = widget.querySelector('[data-gale-variant-data]');
    if (!data) return [];

    try {
      return JSON.parse(data.textContent);
    } catch (error) {
      return [];
    }
  }

  function findVariant(widget, variantId) {
    const variants = readVariants(widget);
    return variants.find((variant) => String(variant.id) === String(variantId));
  }

  function rememberVariant(variant) {
    if (!variant) return;

    try {
      const stored = JSON.parse(localStorage.getItem('galeEligibleVariants') || '[]');
      const next = stored.filter((item) => String(item.id) !== String(variant.id));
      next.push({ id: variant.id, type: variant.type || '' });
      localStorage.setItem('galeEligibleVariants', JSON.stringify(next));
    } catch (error) {
      // localStorage may be unavailable in private browsing or blocked contexts.
    }
  }

  function updateWidget(widget, variantId) {
    if (window.Shopify && window.Shopify.country && window.Shopify.country !== 'US') {
      widget.hidden = true;
      return;
    }

    const variant = findVariant(widget, variantId) || findVariant(widget, widget.dataset.selectedVariantId);
    const type = variant ? variant.type : '';
    const text = widget.querySelector('[data-gale-dynamic-text]');

    widget.hidden = false;
    widget.dataset.selectedVariantId = variant ? variant.id : widget.dataset.selectedVariantId;
    widget.dataset.galeType = type || '';

    if (text) {
      text.textContent = labelForType(type);
    }

    rememberVariant(variant);
  }

  function modalSteps(type) {
    const steps = [
      ['Checkout as guest', 'Complete checkout without creating an account.'],
      ['Select Gale at Checkout', 'Choose the HSA/FSA payment option during checkout.'],
    ];

    if (type === 'dual_purpose') {
      steps.push(['Complete a health assessment', 'Qualified customers may be asked to complete a short eligibility assessment.']);
    }

    steps.push(['Pay with HSA/FSA or credit card', 'Use eligible HSA/FSA funds or another payment method to finish your order.']);

    return steps;
  }

  function createModal(type) {
    const existingModal = document.getElementById(MODAL_ID);
    if (existingModal) {
      existingModal.remove();
    }

    const modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'gale-hsa-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'gale-hsa-modal-title');

    const steps = modalSteps(type)
      .map((step, index) => `
        <div class="gale-hsa-modal__step">
          <span class="gale-hsa-modal__badge">Step ${index + 1}</span>
          <h3 class="gale-hsa-modal__step-title">${step[0]}</h3>
          <p class="gale-hsa-modal__step-copy">${step[1]}</p>
        </div>
      `)
      .join('');

    modal.innerHTML = `
      <div class="gale-hsa-modal__panel">
        <div class="gale-hsa-modal__header">
          <p class="gale-hsa-modal__brand">Gale</p>
          <button class="gale-hsa-modal__close" type="button" aria-label="Close">
            <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
              <path d="m5.2 4.3 4.8 4.8 4.8-4.8.9.9-4.8 4.8 4.8 4.8-.9.9-4.8-4.8-4.8 4.8-.9-.9 4.8-4.8-4.8-4.8.9-.9Z" fill="currentColor"/>
            </svg>
          </button>
        </div>
        <h2 class="gale-hsa-modal__title" id="gale-hsa-modal-title">Maximize your savings.<br>Pay with FSA &amp; HSA.</h2>
        <p class="gale-hsa-modal__intro">Here is how to use your HSA/FSA funds.</p>
        <div class="gale-hsa-modal__steps">${steps}</div>
        <button class="gale-hsa-modal__action" type="button">Close</button>
      </div>
    `;

    modal.addEventListener('click', (event) => {
      if (
        event.target === modal ||
        event.target.closest('.gale-hsa-modal__close') ||
        event.target.closest('.gale-hsa-modal__action')
      ) {
        modal.removeAttribute('open');
      }
    });

    document.body.appendChild(modal);
    return modal;
  }

  function openModal(widget) {
    const modal = createModal(widget.dataset.galeType || '');
    modal.setAttribute('open', '');

    const closeButton = modal.querySelector('.gale-hsa-modal__close');
    if (closeButton) {
      closeButton.focus();
    }
  }

  function initWidget(widget) {
    if (widget.dataset.galeInitialized === 'true') {
      updateWidget(widget, widget.dataset.selectedVariantId);
      return;
    }

    widget.dataset.galeInitialized = 'true';
    updateWidget(widget, widget.dataset.selectedVariantId);

    const trigger = widget.querySelector('[data-gale-modal-trigger]');
    if (trigger) {
      trigger.addEventListener('click', () => openModal(widget));
    }
  }

  function initAll() {
    document.querySelectorAll('[data-gale-hsa-widget]').forEach(initWidget);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('change', (event) => {
    if (!event.target.matches("select[name='id'], input[name='id']")) return;

    document.querySelectorAll('[data-gale-hsa-widget]').forEach((widget) => {
      updateWidget(widget, event.target.value);
    });
  });
})();
